let unauthorizedHandler = null;
let forbiddenHandler = null;

export function setAuthSessionHandlers({ onUnauthorized, onForbidden } = {}) {
  unauthorizedHandler = onUnauthorized || null;
  forbiddenHandler = onForbidden || null;
}

export function notifyUnauthorized() {
  unauthorizedHandler?.();
}

export function notifyForbidden() {
  forbiddenHandler?.();
}
